import { queryElement as r } from "./utils.js";
function f(e, n) {
  if (e === void 0)
    return !1;
  if (n) {
    const { context: { ids: t } } = n;
    return t.has(e);
  }
  return r(e) !== null;
}
export {
  f as exists
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/css-render@0.15.14/~/css-render/esm/exists.js
// module id = 1324
// module chunks = 41